import "./holydays.css";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { getWidgetCredentialsQuery } from "@src/graphQl/querys/widgetsQuerys.js";
import { compareDates } from "@store/action/GlobalAction";
import { Badge } from "reactstrap";
import { getHolydaysData } from "../../../graphQl/querys/widgetsQuerys";
import axios from "axios";

const Holydayswidgets = () => {
  const [holydays, setHolydays] = useState([]);
  const [country, setCountry] = useState("GB");
  const [year, setYear] = useState("2022");
  const [Geolocation, setGeolocation] = useState({});
  const [nextHoliday, setNextHoliday] = useState(2);

  const { id } = useParams();
  const API = process.env.REACT_APP_QUIZZ_ENDPOINT;
  const ENDPOINT = process.env.REACT_APP_QUERY_ENDPOINY;
  useEffect(() => {
    getFullYear();
    // sync(fetchData);
    axios
      .post(`${API}/${ENDPOINT}/graphql`, { query: getHolydaysData("TN") })
      .then((res) => {
        const weatherDataJSON = res?.data?.data?.widgetDatum?.API_data;
        const weatherData = JSON.parse(weatherDataJSON);
        setHolydays(weatherData);
      });
  }, [year]);

  const getFullYear = () => {
    const d = new Date();
    const thisyear = d.getFullYear();
    setYear(() => thisyear);
  };

  const sync = (fn) => {
    getGeolocation(fn);
  };

  const getGeolocation = (fn) => {
    navigator.geolocation.getCurrentPosition((position) => {
      const { latitude, longitude } = position.coords;
      getLocation(fn, { latitude, longitude });
      setGeolocation(() => ({ latitude, longitude }));
    });
  };

  const getLocation = (fn, Geolocation) => {
    let locationData = `lat=${Geolocation.latitude}&lon=${Geolocation.longitude}`;
    const endpoint = `${process.env.REACT_APP_GETLOCATIIN_API}/2.5/forecast?${locationData}&appid=${process.env.REACT_APP_WEATHER_API_KEY}&units=metric`;
    axios.get(endpoint).then(({ data }) => {
      const { city } = data;
      setCountry(city.country);

      axios
        .post(
          `${process.env.REACT_APP_QUIZZ_ENDPOINT}/${process.env.REACT_APP_QUERY_ENDPOINY}`,
          { query: getWidgetCredentialsQuery(id) }
        )
        .then((res) => {
          const options = {
            method: "GET",
            url: `${process.env.REACT_APP_HOLIDAYS_ENPOINT}${year}/${city.country}`,
            headers: {
              "X-RapidAPI-Key": `${res.data.data.getCredentials.Token}`,
              "X-RapidAPI-Host": `public-holiday.p.rapidapi.com`,
            },
          };
          fn(options);
        });
    });
  };

  const { t } = useTranslation();
  return (
    <>
      <section className="single-banner">
        <div className="container__">
          <div className="row">
            <div className="col-lg-12">
              <div className="single-content">
                <h2>{t("holydays")}</h2>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("Home")}</Link>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="holydaysContainer">
        {holydays.map((ele, i) => (
          <div
            key={i}
            style={{
              backgroundSize: "350px 350px",
              backfaceVisibility: "revert-layer",
            }}
            className={nextHoliday < i ? "nextHolyday" : "holidayItemContainer"}
          >
            <div className="holydayCardHeader">
              {" "}
              <h4>{t(`${ele.localName}`)}</h4>{" "}
            </div>

            <img
              style={{ borderRadius: "50%" }}
              src="https://aux4.iconspalace.com/uploads/721658831847002406.png"
            />

            <p>{ele.date}</p>
            {compareDates(ele.date) ? (
              <Badge
                style={{ width: "100%", fontSize: "15px" }}
                color="light-danger"
              >
                {t(`passed`)}
              </Badge>
            ) : (
              <Badge
                style={{ width: "100%", fontSize: "15px" }}
                color="light-success"
              >
                {t(`comming`)}
              </Badge>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default Holydayswidgets;
